import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {OverlayService} from '../../overlay';
import {ModalService} from '../modal.service';
import {ALERT_COMMON_STRINGS} from './alert-common-strings';

@Component({
    selector: 'alert-modal',
    templateUrl: './alert-modal.component.html',
    styleUrls: ['./alert-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertModalComponent implements OnInit {

    @Input()
    public alertTitle: string;

    @Input()
    public alertTitleTranslate: boolean = true;

    @Input()
    public alertMessage: string;

    @Input()
    public alertMessageTranslate: boolean = true;

    @Input()
    public alertMessageTranslationParams: { [key: string]: string } = null;

    @Input()
    public alertButtonText: string = ALERT_COMMON_STRINGS.buttonOk;

    constructor(
        private modalService: ModalService,
        private overlayService: OverlayService
    ) {}

    public ngOnInit(): void {
        this.createOverlay();
    }

    public close(): void {
        this.modalService.close(this);
    }

    private createOverlay(): void {
        this.overlayService.create({
            target: this.modalService.getByInstance(this)
        }).subscribe(() => this.close());
    }

}
